var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUneMachineACafe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 62 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 794",
    d: "M55.66 51.321H6.343a1.28 1.28 0 0 1-1.3-1.261V17.282a1.3 1.3 0 0 1 2.6 0v31.516h46.723V37.452a1.3 1.3 0 0 1 2.6 0v12.607a1.28 1.28 0 0 1-1.306 1.262Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Ligne 62",
    d: "M55.697 23.117a1.261 1.261 0 0 1-1.261-1.264V16.81a1.261 1.261 0 0 1 1.261-1.257 1.261 1.261 0 0 1 1.261 1.261v5.039a1.261 1.261 0 0 1-1.261 1.264Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Ellipse 192",
    d: "M31.001 8.824a5.048 5.048 0 0 1 5.043 5.043 5.048 5.048 0 0 1-5.043 5.043 5.048 5.048 0 0 1-5.043-5.043 5.048 5.048 0 0 1 5.043-5.043Zm0 7.564a2.524 2.524 0 0 0 2.521-2.521 2.524 2.524 0 0 0-2.521-2.521 2.524 2.524 0 0 0-2.521 2.521 2.524 2.524 0 0 0 2.521 2.521Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Ellipse 193",
    d: "M11.346 5.043a3.786 3.786 0 0 1 3.782 3.782 3.786 3.786 0 0 1-3.782 3.782 3.786 3.786 0 0 1-3.782-3.782 3.786 3.786 0 0 1 3.782-3.782Zm0 5.043a1.262 1.262 0 0 0 1.261-1.261 1.262 1.262 0 0 0-1.261-1.261 1.262 1.262 0 0 0-1.261 1.261 1.262 1.262 0 0 0 1.261 1.261Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 795",
    d: "M3.875 0h54.25A3.834 3.834 0 0 1 62 3.782v10.085a3.834 3.834 0 0 1-3.875 3.782H46.5c-2.431 0-3.06 1.227-4.011 3.085-1.022 2-2.295 4.479-6.322 4.479H25.833c-4.027 0-5.3-2.483-6.322-4.479-.952-1.858-1.58-3.085-4.011-3.085H3.875A3.834 3.834 0 0 1 0 13.867V3.782A3.834 3.834 0 0 1 3.875 0Zm54.25 15.128a1.278 1.278 0 0 0 1.292-1.261V3.782a1.278 1.278 0 0 0-1.292-1.261H3.875a1.278 1.278 0 0 0-1.292 1.261v10.085a1.278 1.278 0 0 0 1.292 1.261H15.5c4.027 0 5.3 2.483 6.322 4.479.952 1.858 1.58 3.085 4.011 3.085h10.334c2.431 0 3.06-1.227 4.011-3.085 1.022-2 2.295-4.479 6.322-4.479Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 796",
    d: "M45.878 10.085a1.891 1.891 0 1 1 1.891-1.891 1.893 1.893 0 0 1-1.891 1.891Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 797",
    d: "M52.545 10.085a1.891 1.891 0 1 1 1.891-1.891 1.893 1.893 0 0 1-1.891 1.891Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2440",
    d: "M3.875 49.394h54.25A3.834 3.834 0 0 1 62 53.176v5.043a3.834 3.834 0 0 1-3.875 3.782H3.875A3.834 3.834 0 0 1 0 58.219v-5.043a3.834 3.834 0 0 1 3.875-3.782Zm54.25 10.085a1.278 1.278 0 0 0 1.292-1.261v-5.043a1.278 1.278 0 0 0-1.292-1.261H3.875a1.278 1.278 0 0 0-1.292 1.261v5.043a1.278 1.278 0 0 0 1.292 1.261Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 798",
    d: "M22.176 38.995h17.649a1.261 1.261 0 0 1 1.261 1.261v1.261a10.085 10.085 0 1 1-20.17 0v-1.261a1.261 1.261 0 0 1 1.26-1.261Zm16.388 2.521H23.436a7.564 7.564 0 1 0 15.128 0Z",
    fill: "currentColor"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 799",
    d: "M25.958 23.362h10.085a1.261 1.261 0 0 1 1.261 1.261v6.3a2.524 2.524 0 0 1-2.521 2.521h-7.564a2.524 2.524 0 0 1-2.521-2.521v-6.3a1.261 1.261 0 0 1 1.26-1.261Zm8.825 2.521h-7.564v5.043h7.564Z",
    fill: "currentColor"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Ligne 63",
    d: "M31 36.111a1.261 1.261 0 0 1-1.261-1.261v-2.521A1.261 1.261 0 0 1 31 31.068a1.261 1.261 0 0 1 1.261 1.261v2.521A1.261 1.261 0 0 1 31 36.111Z",
    fill: "currentColor"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Ligne 64",
    d: "M47.73 30.967H36.385a1.261 1.261 0 0 1-1.261-1.26 1.261 1.261 0 0 1 1.261-1.261H47.73a1.261 1.261 0 0 1 1.261 1.261 1.261 1.261 0 0 1-1.261 1.26Z",
    fill: "currentColor"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 800",
    d: "M49.393 25.922h8.824a3.782 3.782 0 1 1 0 7.564h-8.824a2.524 2.524 0 0 1-2.521-2.521v-2.521a2.524 2.524 0 0 1 2.521-2.522Zm8.824 5.043a1.261 1.261 0 1 0 0-2.521h-8.825v2.521Z",
    fill: "currentColor"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 801",
    d: "M43.321 47.734a1.261 1.261 0 0 1 0-2.521 1.891 1.891 0 0 0 0-3.782h-3.152a1.261 1.261 0 0 1 0-2.521h3.152a4.412 4.412 0 1 1 0 8.825Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUneMachineACafe);
export default __webpack_public_path__ + "static/media/une-machine-a-cafe.aa479d7c978067adeaf2848a93b60cd2.svg";
export { ForwardRef as ReactComponent };